import {Component, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class LiveMeta extends Vue {
	mounted(): void {
		this.changeMetaTitle();
	}

	@Watch('$route.path')
	onRoutePathChanged(): void {
		this.changeMetaTitle();
	}

	changeMetaTitle(): void {
		if (typeof window === 'undefined') {
			return;
		}

		const titleContent = this.$t(`meta.${this.$route.name!.split('-')[0]}.title`) as string;
		let titleElement = window.document.head.querySelector('title');

		if (titleElement) {
			titleElement.innerText = titleContent;

			return;
		}

		titleElement = document.createElement('title');
		titleElement.innerText = titleContent;

		window.document.head.appendChild(titleElement);
	}
}
